export default "__VITE_ASSET__e81a5146__"